import { issuerService } from "../services/issuers.service";
import { postCardIssuerConstants, issuer_namespace } from "../constants/issuers.constants";

export const getPostcardIssuers = () => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await issuerService.getPostCardIssuers();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request() {
    return { type: postCardIssuerConstants[`GET_${issuer_namespace}_REQUEST`] };
  }
  function success(response) {
    return { type: postCardIssuerConstants[`GET_${issuer_namespace}_SUCCESS`], response };
  }
  function failure(error) {
    return { type: postCardIssuerConstants[`GET_${issuer_namespace}_FAILURE`], error };
  }
};
